import React from "react";
import { Navigate } from "react-router-dom";
import { auth } from "../firebaseConfig";
import { useAuthState } from "react-firebase-hooks/auth";
import Loader from "./Loader";

export default function ProtectedRoute({ children }) {
  const [user, loading] = useAuthState(auth);

  if (loading) return <Loader />;

  if (!user) return <Navigate to="/login" replace />;

  return children;
}
